import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { useIntl } from 'react-intl-next';
import StarIcon from '@atlaskit/icon/glyph/star';
import StarFilledIcon from '@atlaskit/icon/glyph/star-filled';
import { Pressable, xcss } from '@atlaskit/primitives';
import messages from './messages';
var pressableStarIconStyles = xcss({
  background: 'transparent',
  padding: 'space.0',
  height: '32px',
  width: '32px'
});
var hiddenStyles = xcss({
  opacity: 0
});
export var StarIconButton = function StarIconButton(_ref) {
  var isStarred = _ref.isStarred,
    handleToggle = _ref.handleToggle,
    _ref$visible = _ref.visible,
    visible = _ref$visible === void 0 ? true : _ref$visible;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHovered = _useState2[0],
    setIsHovered = _useState2[1];
  return /*#__PURE__*/React.createElement(Pressable, {
    xcss: [pressableStarIconStyles, !visible && hiddenStyles],
    onClick: handleToggle,
    onMouseEnter: function onMouseEnter() {
      return setIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovered(false);
    }
  }, isStarred || isHovered ? /*#__PURE__*/React.createElement(StarFilledIcon, {
    size: "medium",
    label: formatMessage(messages.removeFromFavouritesLabel),
    primaryColor: "var(--ds-background-accent-yellow-subtler-pressed, #E2B203)"
  }) : /*#__PURE__*/React.createElement(StarIcon, {
    size: "medium",
    label: formatMessage(messages.clickToFavouriteLabel),
    primaryColor: "var(--ds-background-accent-gray-bolder-hovered, #44546F)"
  }));
};